import type { ReactNode } from 'react'
import { ThemeToggle } from '../../components/ThemeToggle'

/** Общая рамка экранов входа: одна карточка по центру, никакого меню — сессии ещё нет. */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="flex min-h-full items-center justify-center bg-surface-2 px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 flex items-center gap-2">
          <span className="grid h-8 w-8 place-items-center rounded-md bg-accent text-accent-fg">П</span>
          <span className="text-lg font-semibold tracking-tight">Переговорки</span>
          {/* Тема переключается и до входа: раньше тумблер жил только в шапке
              приложения, и человек с тёмной системной темой встречал систему
              светлым экраном, изменить который было нечем. */}
          <ThemeToggle className="ml-auto" />
        </div>
        <div className="card p-6 shadow-pop">
          <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  )
}
